import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './NotFoundPage.css';

export const NotFoundPage = () => {
  return (
    <>
      <Helmet>
        <title>404 - Ingredient Not Found | POM Data</title>
        <meta name="description" content="The ingredient you're looking for doesn't exist in our database." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="not-found-page">
        <div className="not-found-content">
          <h1>404</h1>
          <h2>Ingredient Not Found</h2>
          <p>
            Sorry, we couldn't find information about this ingredient in our database.
          </p>
          <p className="suggestion">
            Please check the ingredient name and try again, or browse our available ingredients.
          </p>
          <Link to="/" className="home-link">
            Return to Home
          </Link>
        </div>
      </div>
    </>
  );
};
